/**
 * Type of vermouth.
 */
export type VermouthType = 'EXTRA_DRY' | 'BIANCO' | 'RED';

export const VermouthType = {
  ExtraDry: 'EXTRA_DRY' as VermouthType,
  Bianco: 'BIANCO' as VermouthType,
  Red: 'RED' as VermouthType,
};
